module.exports = __webpack_public_path__ + "static/media/33.91298817.wav";